import React from 'react';

export const Highlighter = ({
    text,
    searchValue = '',
}: {
    text: string;
    searchValue: string | '';
}) => {
    if (!searchValue) return <span>{text}</span>;

    // Create regex based upon search value and split it.
    // Other option would be to use replace but thats mean setting dangeriouslyHMTL of React ;)
    const regex = new RegExp(`(${searchValue})`, 'gi');
    const highlightedParts = text.split(regex);
    const finalText = highlightedParts.map((text, index) =>
        regex.test(text) ? <mark key={index}>{text}</mark> : text,
    );

    return <span>{finalText}</span>;
};
